/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import {  Alert } from '@material-ui/lab'
import notice from "../../../utils/notice";
import {
  MuiThemeProvider,
  Button,
  useMediaQuery,
  Tooltip,
  IconButton,
  CircularProgress,
  makeStyles
} from "@material-ui/core";
import { Add, Delete, Visibility, Publish, GetApp } from "@material-ui/icons";
import MUIDataTable from "mui-datatables";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";

import { actionTableMuiTheme } from "../../table/table_styles";
import StaffDialog from "./StaffDialog";
import PasswordReset from "../PasswordReset";
import FilterDataTable from "../../../utils/FilterDataTable";

import { setLoader } from "../../../../redux/ducks/load.duck";
import * as staffMDUCK from "../../../../redux/ducks/staff_members.duck";
import { BulkModal } from "../../../utils/BulkModal";
import { BulkJobStatus } from "../../../utils/BulkJobStatus";
import {
  defaultStaffMember,
  getStaffMembers,
  getStaffMember,
  deleteStaffMember,
  checkStateBulk,
  validateStaffBulkFetch,
  generatePresignedUrl,
  staffBulk,
  getAllStaffMembers,
} from "../../../crud/api/staff_members.crud";
import { downloadCsv } from "../../../utils/downloadCsv";
import { setAlert } from "../../../../redux/ducks/alert.duck";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CustomTableFooter from "../../../utils/CustomTableFooter";
const useStyles = makeStyles(theme => ({
  paper: {
    width: ({ isDesktop }) => !isDesktop ? '70%' : '50%',
    [theme.breakpoints.up('sm')]: {
      width: '40%'
    },
    maxWidth: 500,
  },
  alertLeft:{
    display: 'inline-flex !important',
    right: 4 
  },
  progress: {
    marginLeft: 10,
    
  }
}));
const Staff = ({
  settingLoader,
  staffMActions,
  staffMembers,
  school,
  setAlert,
  staff_member_admin,
  is_admin,
}) => {
  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isTablet = useMediaQuery("(min-width: 768px)");
  const [dialog, setDialog] = useState("close");
  const [email, setEmail] = useState("");
  const [query, setQuery] = useState("");
  const [bulk, setBulk] = useState(null);
  const [stepsBulk, setStepsBulk] = useState(1);
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [urlFile, setUrlFile] = useState("");
  const [errorsBulk, setErrorsBulk] = useState([]);
  const [csvLoading, setCsvLoading] = useState(false);
  const classes = useStyles({ isDesktop });
  useEffect(() => {
    if (school && school !== null && school.slug && school.slug !== null) {
      if (query && query.length > 1)
        getStaffMembers(staffMActions.setStaffMembers, school.slug, 1, query);
      else getStaffMembers(staffMActions.setStaffMembers, school.slug, 1);
    }
  }, [query, school, staffMActions.setStaffMembers]);

  const handleDownloadCsv = async () => {
    if (!school?.slug) {
      notice("Please select a school");
      return;
    }
    setCsvLoading(true);
    try {
      const items = await getAllStaffMembers(school.slug);
      const headers = [
        "First Name",
        "Last Name",
        "Email",
        "Role",
        "Team(s)",
        "Organization",
        "Status",
      ];
      const rows = items.map((item) => [
        item.user?.first_name || "",
        item.user?.last_name || "",
        item.user?.email || "",
        "Staff",
        (item.teams || []).map((t) => t.name).join(", "),
        school.name || "",
        item.user?.active ? "Active" : "Inactive",
      ]);
      downloadCsv(headers, rows, `${school.slug}_staff.csv`);
    } catch (e) {
      console.error(e);
      notice("Error downloading CSV");
    } finally {
      setCsvLoading(false);
    }
  };

  // Build the bulk-staff CSV template in the browser so it always
  // matches the columns the importer reads (incl. the `sport` column)
  // and doesn't depend on a hosted file.
  const handleDownloadTemplate = () => {
    const headers = [
      "first_name",
      "last_name",
      "email",
      "phone_number",
      "prefix",
      "role",
      "short_bio",
      "display_in_telehelp",
      "telehelp_group",
      "include_in_escalation",
      "sport",
    ];
    const rows = [
      ["Jane", "Smith", "jsmith@example.edu", "7175551234", "Coach", "Head Coach", "Leads the program.", "Yes", "Coaches", "Yes", "Women's Basketball"],
      ["John", "Doe", "jdoe@example.edu", "7175555678", "Coach", "Assistant Coach", "", "No", "", "No", "Women's Basketball, Men's Basketball"],
      ["Mary", "Jones", "mjones@example.edu", "7175559012", "Dr.", "Athletic Trainer", "Sports medicine staff.", "Yes", "Medical", "Yes", ""],
    ];
    downloadCsv(headers, rows, "bulk_staff_members_template.csv");
  };

  const deleteStaff = (id) => {
    setAlert({
      title: "Delete Staff Member",
      message: "Are you sure to permanently delete this Staff Member?",
      btn_msg: "Delete Staff Member",
      action: () => deleteStaffMember(staffMActions.deleteStaffMembers, id),
    });
  };

  const columns = [
    {
      name: "user",
      label: "Picture",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value &&
          value.avatar_thumb && (
            <div
              style={{
                background: `url(${value.avatar_thumb}) center center / cover no-repeat`,
                height: 40,
                width: 40,
                borderRadius: "50%",
                margin: "-5px 0",
              }}
            />
          ),
      },
    },
    {
      name: "user",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value && (
            <>
              {value.first_name} {value.last_name}
            </>
          ),
      },
    },
    {
      name: "user",
      label: "Email",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => value && <>{value.email}</>,
      },
    },
    // {
    //   name: 'staff_type',
    //   label: 'Staff type',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value) => (
    //       value && <>{value.name}</>
    //     )
    //   }
    // },
    {
      name: "created_at",
      label: "Date Registered",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value && <>{moment(value).format("MMM DD YYYY")}</>,
      },
    },
    {
      name: "job_title",
      label: "Role",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (job_title) => job_title && <>{job_title}</>,
      },
    },
    {
      name: "display_in_telehelp",
      label: "Staff Support",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) =>
          value && <NotificationsIcon className="w-100" />,
      },
    },
    {
      name: "id",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, meta) =>
          value && (
            <div className="d-flex">
              <Tooltip title="Edit Staff Member" placement="top">
                <IconButton
                  id={`edit_staff_member_btn_${value}`}
                  size="small"
                  onClick={() => openDialog("editing", value)}
                  aria-label="Edit Staff Member"
                >
                  {staff_member_admin || is_admin ? (
                    <i className="fas fa-edit text-primary" />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </Tooltip>
              {(staff_member_admin || is_admin) && (
                <Tooltip title="Delete Staff Member" placement="top">
                  <IconButton
                    id={`delete_staff_member_btn_${value}`}
                    size="small"
                    className="mx-3"
                    onClick={() => deleteStaff(value)}
                    aria-label="Delete Staff Member"
                  >
                    <Delete color="error" />
                  </IconButton>
                </Tooltip>
              )}
              {/* <Tooltip title="Edit Password" placement="top">
              <a id={`passw_change_staff_member_btn_${value}`} className="btn btn-icon btn-sm btn-light btn-hover-warning text-warning" onClick={() => {setEmail(meta.rowData[0].email)}}>
                <VpnKey />
              </a>
            </Tooltip> */}
            </div>
          ),
      },
    },
  ];

  const options = {
    serverSide: true,
    rowsPerPageOptions: [],
    rowsPerPage: staffMembers.rowsPerPage,
    page: staffMembers.page,
    count: staffMembers.count,
    rowHover: false,
    search: false,
    sort: false,
    print: false,
    filter: false,
    viewColumns: false,
    download: false,
    selectableRows: "none",
    tableBodyMaxHeight: isDesktop ? "670px" : isTablet ? "640px" : "357px",
    textLabels: {
      body: {
        noMatch: "No data",
      },
      pagination: {
        next: "Next",
        previous: "Previous",
        rowsPerPage: "Rows:",
        displayRows: "of",
      },
    },
    downloadOptions: {
      filename: "staff_members.csv",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayRowsOnly: true,
      },
    },
    customFooter: (count, page, rowsPerPage) => (
      <CustomTableFooter
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onChangePage={(mPage) => {
          settingLoader(true);
          getStaffMembers(staffMActions.setStaffMembers, school.slug, mPage, query)
            .catch(() => {})
            .finally(() => settingLoader(false));
        }}
      />
    ),
  };

  const openDialog = (mode, id = null) => {
    switch (mode) {
      case "create":
        settingLoader(true);
        staffMActions.setStaffMember(defaultStaffMember);
        setDialog(mode);
        break;
      case "editing":
        settingLoader(true);
        getStaffMember(staffMActions.setStaffMember, id).then(() =>
          setDialog(mode)
        );
        break;
      case "close":
        setDialog(mode);
        setTimeout(() => staffMActions.setStaffMember(defaultStaffMember), 500);
        break;
      default:
        console.error("Invalid dialog mode");
    }
  };

  const createStaffBulk = () => {
    setBulkModal(false)
    setBulkLoading(true);
    if (!school?.slug) {
      setBulkLoading(false);
      notice("Please select a school");
    } else if (!bulk) {
      setBulkLoading(false);
      notice("Please add a csv file");
    } else
      
    staffBulk(school.slug, urlFile)
      .then((response) => {


        const intervalIdentifierC = setInterval(async () => {
          try {
            await _checkStateBulk(response.id, 6, 6.1);
          } catch (e) {
            clearInterval(Number(localStorage.getItem('idInterval')));
            localStorage.removeItem('idInterval');
            setBulkLoading(false);
            notice("Error checking bulk upload status");
            console.error(e);
          }
        }, 5000);
        localStorage.setItem('idInterval', intervalIdentifierC);

        setBulk(null);
        setStepsBulk(4);
        // setTimeout(
        //   () =>
        //     getStudents(studentActions.setStudents, school.slug, 1, query),
        //   2000
        // );
        setTimeout(
          () =>{
            setBulkLoading(true);
            setStepsBulk(5)},
          2000
        );
      })
      .catch((e) => {
        setBulkLoading(false);
        notice("Error starting bulk upload");
        console.error(e);
      });
  };
  const onFinish = () => {
    setStepsBulk(1)
    setBulkModal(false);
    //getStudents(studentActions.setStudents, school.slug, 1, query);
  }
  const _checkStateBulk = async (id_background, nextStep, stepError) => {
    const res = await checkStateBulk(id_background);
    if (res.state === "success") {
      clearInterval(Number(localStorage.getItem('idInterval')));
      localStorage.removeItem('idInterval');
      setStepsBulk(nextStep);
      setBulkLoading(false);

    }

    if (res.state === "error") {
      setErrorsBulk(res.result.errors);
      clearInterval(Number(localStorage.getItem('idInterval')));
      localStorage.removeItem('idInterval');
      setStepsBulk(stepError);
      setBulkLoading(false);

    }

  }
  const validateStudentBulk = async (values) => {

    setBulkLoading(true);
    if (!school?.slug) {
      setBulkLoading(false);
      notice("Please select a school");
    } else if (!bulk) {
      setBulkLoading(false);
      notice("Please add a csv file");
    } else {
      setStepsBulk(2);
      const result = await uPloadFiletoS3();
      if (result === false) {

        return;
      }
      setUrlFile(result);
      validateStaffBulkFetch(school.slug, result)
        .then((response) => {

          const intervalIdentifierC = setInterval(async () => {
            try {
              await _checkStateBulk(response.id, 3, 2.2);
            } catch (e) {
              clearInterval(Number(localStorage.getItem('idInterval')));
              localStorage.removeItem('idInterval');
              setBulkLoading(false);
              notice("Error checking bulk validation status");
              console.error(e);
            }
          }, 5000);
          localStorage.setItem('idInterval', intervalIdentifierC);


        })
        .catch(() => { setErrorsBulk(["Error. internal error please contact administrator"]);setStepsBulk(2.2); setBulkLoading(false) });

    }
  };
  const uPloadFiletoS3 = async () => {

    const responseUploadUrl = await generatePresignedUrl(bulk.name).catch( error => {
      setErrorsBulk(["Error. internal error please contact administrator"]);
      setStepsBulk(2.2);
      setBulkLoading(false)});
      
    if(responseUploadUrl === undefined)
      return false;
    var res = await fetch(responseUploadUrl.uploadUrl, {
      method: 'PUT',
      body: bulk
    }).then(res => res)
      .catch(error => {
        setBulkLoading(false);
        setStepsBulk(2.1);

        return false
      })
      .then(response => response);

    if (res === undefined)
      return false;

    return responseUploadUrl.key
  }
  return (
    <>
      <div className="table-container">
        <div className="pb-4 d-flex justify-content-between align-items-end">
          <FilterDataTable query={query} setQuery={setQuery} />

          {(staff_member_admin || is_admin) && (
            <div>
              <BulkJobStatus
                stepsBulk={stepsBulk}
                onFinish={onFinish}
                errorsBulk={errorsBulk}
                entity="staff"
              />
              {is_admin && (
                <Button
                  id="download_staff_csv_btn"
                  className="mr-3"
                  variant="contained"
                  color="default"
                  onClick={handleDownloadCsv}
                  startIcon={csvLoading ? <CircularProgress size={18} color="inherit" /> : <GetApp />}
                  disabled={csvLoading}
                >
                  {csvLoading ? "Downloading..." : "Download CSV"}
                </Button>
              )}

              <Button
                id="create_bulk_staff_btn"
                className="mr-3"
                variant="contained"
                color="primary"
                onClick={() => setBulkModal(true)}
                startIcon={<Publish />}
              >
                Bulk Upload
              </Button>

              <Alert  classes={classes.alertLeft}  style={{    display: 'none'}} className=" MuiButtonBase-root " severity=""> </Alert>


              <Button
                id="create_staff_member_btn"
                variant="contained"
                color="secondary"
                onClick={() => openDialog("create")}
                startIcon={<Add />}
              >
                New Staff Member
              </Button>
            </div>
          )}

        </div>
        <MuiThemeProvider theme={actionTableMuiTheme()}>
          <MUIDataTable
            // title="Admin"
            columns={columns}
            data={staffMembers.data}
            options={options}
          />
        </MuiThemeProvider>
      </div>
      <StaffDialog mode={dialog} setDialog={openDialog} />
      <PasswordReset email={email} setEmail={setEmail} />
      {bulkModal &&
        <BulkModal
          onDownloadTemplate={handleDownloadTemplate}
          errorsBulk={errorsBulk}
          setSteps={setStepsBulk}
          open={bulkModal}
          validateBulk={validateStudentBulk}
          setOpen={setBulkModal}
          bulk={bulk}
          steps={stepsBulk}
          setBulk={setBulk}

          school={school}
          loading={bulkLoading}
          bulkRequest={createStaffBulk}
          setLoading={setBulkLoading}
        />
      }
    </>
  );
};

const mapStateToProps = (store) => ({
  staffMembers: store.staffM.staffMembers,
  school: store.school.selected_school,
  is_admin: store.auth.user?.is_admin,
  staff_member_admin: store.auth.user?.staff_member_admin,
});

const mapDispatchToProps = (dispatch) => ({
  settingLoader: bindActionCreators(setLoader, dispatch),
  staffMActions: bindActionCreators(staffMDUCK.actions, dispatch),
  setAlert: bindActionCreators(setAlert, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
